import React, { useState,useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import SelectVendor from '../layout/SelectVendor';
import Helper from '../../../helper/Helper';
import { useTranslation } from 'react-i18next';
import { GET_BILL_NUMBER, SAVE_BILL } from '../../../data/url';
import Alert from '../../../feature/Alert';
import httpClient from '../../../http/HttpRequest';
import { useNavigate } from 'react-router-dom';
import ProductCal from '../layout/ProductCal';


export default function NewBill() {

     //variables
     const [state_id, setState] = useState('');
     const [vendor_id, setVendorId] = useState('');
     const [vendor, setVendor] = useState({});
     const { t } = useTranslation();
     const navigate = useNavigate();
     const [errors, setErrors] = useState({});
     const [billDetail, setBillDetails] = useState({ prefix: '', number: '', bill_date: Helper.getToday(), due_date: '', po_number: '', po_date: '', invoice_number: '' });

     //methods
     useEffect(() => {
          getBillNumber();
     }, [])

     const getBillNumber = async (e) => {
          const res = await httpClient.post(GET_BILL_NUMBER, {});
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status === 1) {
                    setBillDetails(prevBillDetails => ({
                         ...prevBillDetails,
                         prefix: result.prefix || '',  
                         number: result.bill_number || ''
                    }));
               }
          }
     }
     const remitVendor = (data) => {
          setVendorId(data.vendor_id);
          setState(data.state_id);
          setVendor(data.vendor);
     }

     const handleInputChange = (fieldName, event) => {
          const value = event.target.value;
          const order = { ...billDetail };
          order[fieldName] = value;
          setBillDetails(order);
     };

     const handelSubmit = (products, commanData, totals, txnType) => {
          if (validateField()) {
               if (products.length > 0) {
                    let p = billDetail;
                    p['vendor_id'] = vendor_id;
                    p['state'] = state_id;
                    p['products'] = products;
                    p['totals'] = totals;
                    p['commonData'] = commanData;
                    p['txnType'] = txnType;                    
                    saveOrder(p);
               } else {
                    Alert.error('Products are empty');
               }

          }
     }

     const saveOrder = async (post) => {
          const res = await httpClient.post(SAVE_BILL, post);
          if (res.requestStatus === "OK") {
               const result = res.result;
               if (result.status == 1) {
                    Alert.success(result.message);
                    navigate('/root/bill');
               } else {
                    Alert.failure(result.message);
               }
          }
     }

     const validateField = () => {
          let formErrors = {};
          let valid = true;
          if (vendor_id === '') {
               Alert.error('Kindly select vendor');
               valid = false;
          }
          setErrors(formErrors);
          return valid;
     }


     return (
          <AdminLayout>
               <div className="content-wrapper">
                    <ContentHeader title="new_bill" subTitle="bills" subTitleLink="root/bill" />
                    <div className='card'>
                         <div className='card-body'>
                              <div>
                                   <SelectVendor remitVendor={remitVendor} />
                              </div>
                              <div className='row mt-2'>
                                   <div className='col-md-4 mt-2'>
                                        <label htmlFor='prefix'>{t('number')}</label>
                                        <div className='input-group'>
                                             <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                                                  <input id='prefix' value={billDetail.prefix} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                                             </div>
                                             <input id='number' value={billDetail.number} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                                        </div>
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='bill_date'>{t('bill_date')}</label>
                                        <input id='bill_date' value={billDetail.bill_date} type='date' name='bill_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('bill_date', e)} />
                                   </div>
                                   <div className='col-md-2 mt-2'>
                                        <label htmlFor='due_date'>{t('due_date')}</label>
                                        <input id='due_date' value={billDetail.due_date} type='date' name='due_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('due_date', e)} />
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='po_number'>{t('po_number')}</label>
                                        <input id='po_number' value={billDetail.po_number} type='text' name='po_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('po_number', e)} />
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='po_date'>{t('po_date')}</label>
                                        <input id='po_date' value={billDetail.po_date} type='date' name='po_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('po_date', e)} />
                                   </div>
                                   <div className='col-md-3 mt-2'>
                                        <label htmlFor='invoice_number'>{t('invoice_number')}</label>
                                        <input id='invoice_number' value={billDetail.invoice_number} type='text' name='invoice_number' className='form-control form-control-sm' onChange={(e) => handleInputChange('invoice_number', e)} />
                                   </div>
                              </div>
                              <ProductCal title="bill" onSubmit={handelSubmit} customer={vendor} />
                         </div>
                    </div>
               </div>
          </AdminLayout>
     )
}
